import { ObjectSchema, Schema, array, mixed, object, string } from 'yup';
import { DashboardView } from '../models/dashboard-view';
import { DashboardPanelType } from '../models/dashboard-panel-type';

const PANEL_TYPES = Object.values(DashboardPanelType);

export function dashboardViewValidator(): ObjectSchema<DashboardView> {
    let dashboardTypeSchemas = {};

    dashboardTypeSchemas[DashboardPanelType.ALARMS] = object({}).strict().noUnknown();

    dashboardTypeSchemas[DashboardPanelType.CHANNEL_GROUP] = object({
        groupId: string().strict().required().nonNullable(),
    })
        .strict()
        .noUnknown();

    dashboardTypeSchemas[DashboardPanelType.CUSTOM_GROUP] =
        dashboardTypeSchemas[DashboardPanelType.CHANNEL_GROUP];

    dashboardTypeSchemas[DashboardPanelType.MIMICS] = object({
        mimicId: string().strict().required().nonNullable(),
    })
        .strict()
        .noUnknown();

    dashboardTypeSchemas[DashboardPanelType.TREND_GRAPH] = object({
        graphId: string().strict().required().nonNullable(),
    })
        .strict()
        .noUnknown();

    let panelObj = object({
        type: string().strict().required().nonNullable().oneOf(PANEL_TYPES),
        params: object()
            .test('is-correct-panel-params', function checkParams() {
                (dashboardTypeSchemas[this.parent.type] as Schema)?.validateSync(
                    this.originalValue,
                );
                return true;
            })
            .strict()
            .required()
            .nonNullable(),
    })
        .required()
        .nullable()
        .strict()
        .noUnknown();

    return object({
        id: string().optional(),
        panels: array().of(panelObj).strict().required().nonNullable().length(4),
    })
        .strict()
        .noUnknown() as unknown as ObjectSchema<DashboardView>;
}
